if (!customElements.get('noonaway-glass-footer')) {
  customElements.define(
    'noonaway-glass-footer',
    class NoonawayGlassFooter extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;

        this.video = this.querySelector('[data-nwa-footer-video]');
        this.motionButton = this.querySelector('[data-nwa-footer-motion]');
        this.pauseLabel = this.querySelector('[data-nwa-footer-pause]');
        this.playLabel = this.querySelector('[data-nwa-footer-play]');
        this.menuItems = [...this.querySelectorAll('[data-nwa-footer-menu]')];
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.desktopLayout = window.matchMedia('(min-width: 768px)');
        this.videoLoadStarted = false;
        this.isVisible = false;
        this.manuallyPaused = false;
        this.userStartedVideo = false;
        this.lastDesktopState = null;

        this.syncMenus();
        this.desktopLayout.addEventListener('change', () => this.syncMenus(), { signal });

        this.querySelectorAll('[data-nwa-footer-localization]').forEach((select) => {
          select.addEventListener('change', () => select.form?.submit(), { signal });
        });

        if (this.video) {
          const revealVideo = () => this.video.classList.add('is-ready');
          this.video.addEventListener('canplay', revealVideo, { signal, once: true });
          this.video.addEventListener('play', () => this.updateMotionState(false), { signal });
          this.video.addEventListener('pause', () => this.updateMotionState(true), { signal });
          if (this.video.readyState >= 3) revealVideo();

          this.observer = new IntersectionObserver(
            (entries) => {
              this.isVisible = entries[0]?.isIntersecting || false;
              if (this.isVisible) {
                this.startVideo();
              } else {
                this.video.pause();
              }
            },
            { rootMargin: '160px 0px' }
          );
          this.observer.observe(this);

          this.reducedMotion.addEventListener(
            'change',
            () => {
              if (this.reducedMotion.matches && !this.userStartedVideo) {
                this.video.pause();
              } else {
                this.startVideo();
              }
            },
            { signal }
          );

          this.updateMotionState(true);
        }

        this.motionButton?.addEventListener(
          'click',
          () => {
            if (!this.video) return;
            if (this.video.paused) {
              this.manuallyPaused = false;
              this.userStartedVideo = true;
              this.startVideo(true);
            } else {
              this.manuallyPaused = true;
              this.video.pause();
            }
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }

      syncMenus() {
        const isDesktop = this.desktopLayout.matches;
        if (this.lastDesktopState === isDesktop) return;
        this.menuItems.forEach((item) => {
          if (isDesktop) {
            item.open = true;
          } else {
            item.open = false;
          }
        });
        this.lastDesktopState = isDesktop;
      }

      startVideo(force = false) {
        if (!this.video || this.manuallyPaused || !this.isVisible && !force) return;
        if (this.reducedMotion.matches && !this.userStartedVideo && !force) return;
        if (!this.videoLoadStarted) {
          this.videoLoadStarted = true;
          this.video.preload = 'auto';
          this.video.load();
        }
        this.video.play().catch(() => this.updateMotionState(true));
      }

      updateMotionState(paused) {
        if (!this.motionButton || !this.pauseLabel || !this.playLabel) return;
        this.pauseLabel.hidden = paused;
        this.playLabel.hidden = !paused;
        const nextLabel = paused ? this.playLabel.textContent : this.pauseLabel.textContent;
        this.motionButton.setAttribute('aria-label', nextLabel.trim());
      }
    }
  );
}
